import {spotheroGet} from 'api';
import {sendSentryException} from 'utils/error-handling';
import {type InventorySpaces} from 'api/inventory/inventory.types';
import {type RawApiResponse} from 'api/api.types';

type GetDefaultInventoryResponse = InventorySpaces;
type GetDefaultInventoryRawResponse =
    RawApiResponse<GetDefaultInventoryResponse>;

/**
 * Gets the default inventory for a given facility
 *
 * @param facilityId
 *
 * @see https://spothero.com/api/v1/docs/endpoints/?new-docs=true#!/Facilities/get_facilities_facility_id_default_inventory
 * @see '/api/v1/facilities/{facilityId}/default-inventory/'
 */
const getDefaultInventory = async (facilityId: number) => {
    try {
        const {data} = await spotheroGet<GetDefaultInventoryRawResponse>(
            `facilities/${facilityId}/default-inventory/`
        );

        return data?.data?.spaces || 0;
    } catch (err) {
        sendSentryException(err);

        throw new Error(err.message);
    }
};

export default getDefaultInventory;
